<template>
  <div class="loan-application-page">
    <HanderNav title="融星贷"></HanderNav>
    <div class="header-conatiner">
      <div class="title-1 channel">融星贷·放心</div>
      <div class="img-box channel">
        <img class="img-1" src="/images/image-1.png" />
      </div>
    </div>
    <div class="main-content">
      <div class="rx-card amount-card">
        <div class="amount-label">
          <img src="/images/icon-amount.png" alt="额度图标" />
          <span>预估额度(元)</span>
        </div>
        <div class="amount-value">
          <div class="amount">
            <span class="currency">¥</span>
            <span class="amount">{{ $format.formatAmount(amount) }}</span>
          </div>
          <span class="btn-lend" :class="{ 'max-selected': isMaxAmountSelected }" @click="selectMaxAmount">
            {{ isMaxAmountSelected ? "已全部" : "全部借出" }}
          </span>
        </div>
        <div class="rate-info">
          <span>年化利率6.8% 起 丨 1,0000 元利息 2 元/天起</span>
          <img src="/images/icon-tip.png" alt="利率图标" />
        </div>
        <div class="amount-select">
          <div v-for="item in amountOptions" :key="item" class="item" :class="{ active: selectedAmount === item }"
            @click="selectAmount(item)">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="rx-card product-details-card">
        <div class="detail-item" style="padding-top: 0">
          <span class="label">借款期限</span>
          <span class="value">最高 36 期</span>
        </div>
        <div class="detail-item">
          <span class="label">还款方式</span>
          <span class="value">随借随还，等额利息</span>
        </div>
        <div class="detail-item">
          <span class="label"> 产品名称</span>
          <span class="value">{{h5_config.product_name||'融星贷'}}</span>
        </div>
        <div class="detail-item" style="padding-bottom: 0">
          <span class="label">助贷平台</span>
          <span class="value">{{h5_config.organization_name}}</span>
        </div>
      </div>

      <div class="mobile-input-container">
        <van-field class="mobile-input" v-model="smsMobile" center clearable label="" placeholder="请输入手机号"></van-field>
      </div>
      <div class="apply-button-container" style="padding: 0">
        <button class="apply-button" :class="{ disabled: !isAgreement }" :disabled="!isAgreement" @click="handleApply">
          <span>立即申请</span>
        </button>
      </div>
      <div class="agreement-section">
        <div class="checkbox-icon" :class="{ active: isAgreement }" @click="toggleAgree">
          <i></i>
        </div>
        <AgreedProtocol v-model="isAgreement" customClass="mt-10" :items="['USER_REGISTRATION']" />
      </div>
      <div v-if="false" class="agreement-text2">
        <p>
          <span class="link-text" @click="openAgreement">《xxxxxxxxxx协议》</span>
        </p>
        <p>
          <span class="link-text" @click="openAgreement">《隐私协议》</span>
          <span class="link-text" @click="openAgreement">《个人信息共享协议》</span>
        </p>
      </div>
      <div class="copyright-box" style="margin-top: 20px;">
        <p v-if="h5_config.service_tel">客服电话：{{h5_config.service_tel}}</p>
        <p>Copyright © {{new Date().getFullYear()}} {{h5_config.organization_name}}</p>
        <p v-if="false">xx科技 版权所有</p>
        <p>{{h5_config.icp_no}}</p>
      </div>
    </div>
    <van-popup v-model="show">
      <div class="rx-card sms-popup">
        <div class="title">短信验证码</div>
        <van-field class="sms-input" v-model="smsCode"  maxlength="4" center clearable label="" placeholder="请输入短信验证码">
          <template #button>
            <van-button class="btn-sms" :disabled="countdown > 0 || sendingCode" @click="sendSmsCode">
              {{ getSmsButtonText }}
            </van-button>
          </template>
        </van-field>
        <div>
          <van-button class="btn-apply" :disabled="!smsCode" @click="submitApplication">
            立即申请
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import HanderNav from "../components/HanderNav.vue";
import AgreedProtocol from '../components/AgreedProtocol.vue';
import { sendSmsCode as sendSmsCodeApi, submitLoanApplication,getDic,uvApi } from "../api";
export default {
  name: "LoanApplicationPage",
  components: {
    HanderNav,
    AgreedProtocol,
  },
  created() {
    var channel_id = this.$route.query?.channel_id
    if (!channel_id) {
      this.$router.push('/404');
      return;
    }
    this.channel_key = channel_id;
    getDic().then(res=>{
      if(res.code==1){
        this.h5_config=res.data.h5_config;
      }
    })
    var url=window.location.href
    uvApi(channel_id,url).then(res=>{
      console.log(res,'uv')
    })
  },
  data() {
    const amountOptions = [50000, 80000, 100000, 150000]; // 可选金额列表
    const defaultAmount = amountOptions[0]; // 默认选择第一个金额
    return {
      h5_config:{},
      agreeType: '',
      show: false,
      isShowAgreement: false,
      isAgreement: true,
      smsMobile: "",
      smsCode: "",
      countdown: 0,
      countdownTimer: null,
      sendingCode: false,
      amount: defaultAmount,
      selectedAmount: defaultAmount,
      amountOptions: amountOptions,
      channel_key: "",
    };
  },
  computed: {
    getSmsButtonText() {
      if (this.sendingCode) {
        return "发送中...";
      }
      if (this.countdown > 0) {
        return `${this.countdown}s后重发`;
      }
      return "发送验证码";
    },

    // 获取最大可借金额
    maxAmount() {
      return Math.max(...this.amountOptions);
    },

    // 检查是否已选择最大金额
    isMaxAmountSelected() {
      return this.selectedAmount === this.maxAmount;
    },
  },
  methods: {
    // 选择金额
    selectAmount(amount) {
      this.selectedAmount = amount;
      this.amount = amount;
    },
    openAgreement(type) {
      this.agreeType = type;
      this.isShowAgreement = true;
    },

    // 选择最大金额（全部借出）
    selectMaxAmount() {
      if (this.isMaxAmountSelected) {
        this.$toast("已经是最大额度了");
        return;
      }
      this.selectAmount(this.maxAmount);
      this.$toast(`已选择最大额度：¥${this.format.formatAmount(this.maxAmount)}`);
    },
    // 验证手机号格式
    validateMobile(mobile) {
      const mobileReg = /^1[3-9]\d{9}$/;
      return mobileReg.test(mobile);
    },

    // 发送短信验证码
    async sendSmsCode() {
      if (!this.smsMobile) {
        this.$toast("请输入手机号码");
        return;
      }

      if (!this.validateMobile(this.smsMobile)) {
        this.$toast("请输入正确的手机号码");
        return;
      }

      this.sendingCode = true;

      try {
        const result = await sendSmsCodeApi(this.smsMobile);
        if (result.code === 1) {
          this.$toast("验证码发送成功");
          if(result.data&&result.data.stage==='approved'){
              this.$router.push(`/last?channel_id=${this.channel_key}&stage=approved`);
              return;
          }
          if(result.data&&result.data.stage==='rejected'){
              this.$router.push(`/last?channel_id=${this.channel_key}&stage=rejected`);
              return;
          }
          this.startCountdown();
        } else {
          this.$toast(result.message || "验证码发送失败");
        }
      } catch (error) {
        console.error("发送验证码失败:", error);
        this.$toast.fail("网络错误，请重试");
      } finally {
        this.sendingCode = false;
      }
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      }, 1000);
    },

    // 申请贷款方法
    handleApply() {
      if (!this.smsMobile) {
        this.$toast("请输入手机号码");
        return;
      }

      if (!this.validateMobile(this.smsMobile)) {
        this.$toast("请输入正确的手机号码");
        return;
      }
      this.$cache.sessionSet("m",this.smsMobile);
      if (!this.isAgreement) {
        this.$toast("请先同意相关协议");
        return;
      }

      this.show = true;
      this.sendSmsCode();
    },

    // 提交申请
    async submitApplication() {
      if (!this.smsCode) {
        this.$toast("请输入验证码");
        return;
      }

      if (this.smsCode.length !== 4) {
        this.$toast("请输入4位验证码");
        return;
      }

      try {
        this.$toast.loading("提交中...");

        const result = await submitLoanApplication({
          channel_key: this.channel_key,
          mobile: this.smsMobile,
          mobile_code: this.smsCode,
          loan_money: this.selectedAmount, // 使用用户选择的金额
        });

        if (result.code === 1) {
          var stage = result.data.stage;
          this.$toast.success("申请提交成功");
          this.$router.push(`/con?channel_id=${this.channel_key}&amount=${this.selectedAmount}&no=${result.data.check_no}`);
          this.show = false;
          if (stage === "rejected") {
            //申请失败
          } else if (stage === "registered") {
            //注册
          } else if (stage === "applied") {
            //已申请
          } else if (stage === "approved") {
            //申请成功
            //this.$router.push(`/last?channel_id=${this.channel_key}&stage=approved`);
          }
        } else {
          this.$toast.fail(result.message || "申请提交失败");
        }
      } catch (error) {
        console.error("提交申请失败:", error);
        this.$toast.fail("提交失败，请重试");
      }
    },

    toggleAgree() {
      this.isAgreement = !this.isAgreement;
    },

    // 处理协议弹窗同意
    handleAgreementAgree() {
      this.isShowAgreement = false;
      this.$toast.success("已同意协议");
    },
  },

  // 组件销毁时清除定时器
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
};
</script>

<style lang="less" scoped>
.btn-apply {
  margin-top: 10px;
  border-radius: 25px;
  width: 300px;
  height: 50px;
  flex-shrink: 0;
  border: 1px solid #cdedff;
  background: linear-gradient(90deg, #4d9bff 0%, #67d1ff 100%);
  box-shadow: 0 4px 4px 0 rgba(3, 92, 242, 0.12);
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px;

  &:disabled {
    background: #cccccc;
    border: 1px solid #cccccc;
    box-shadow: none;
    cursor: not-allowed;
    color: #999999;
  }
}

.loan-application-page {
  position: relative;
  padding: 0 16px;
  background: linear-gradient(180deg, #b9ddf2 0%, #f3fbff 34.95%);
  min-height: 100vh;

  .header-conatiner {
    text-align: left;
    padding: 0 0 0 12px;

    .title-1 {
      color: #254774;
      font-family: "AlimamaShuHeiTi";
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 21px;
    }

    .img-box {
      position: relative;
      width: 116px;
      height: 116px;

      .img-1 {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
      }
    }

    .title-1.channel {
      margin-bottom: 20px;
    }

    .img-box.channel {
      position: absolute;
      right: 20px;
      top: -10px;
    }
  }

  .main-content {
    position: relative;
  }

  // 额度显示卡片
  .amount-card {
    position: relative;
    background: linear-gradient(180deg, #eef7fc 0%, #fafdff 100%);

    .amount-label {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 10px;

      img {
        width: 16px;
        height: 16px;
      }

      span {
        font-family: "Source_Han_Sans_CN", sans-serif;
        font-size: 14px;
        color: #698691;
        line-height: 21px;
      }
    }

    .amount-value {
      display: flex;

      .amount {
        display: flex;
        align-items: baseline;
        gap: 4px;
        flex: 1;
      }

      .currency {
        font-weight: bold;
        font-size: 24px;
        color: #254774;
        line-height: 48px;
      }

      .amount {
        font-weight: bold;
        font-size: 48px;
        color: #254774;
        line-height: 48px;
      }

      .amount-input {
        font-weight: bold;
        font-size: 48px;
        color: #254774;
        line-height: 48px;
        border: none;
        background: transparent;
        outline: none;
        width: auto;
        min-width: 200px;
        max-width: 300px;
        text-align: left;
        padding: 0;
        margin: 0;

        &::placeholder {
          color: #b0c4de;
          font-weight: normal;
        }

        &:focus {
          background: rgba(37, 71, 116, 0.05);
          border-radius: 4px;
          padding: 0 8px;
        }
      }

      .btn-lend {
        background: #254774;
        width: 76px;
        height: 38px;
        border-radius: 19px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        user-select: none;

        &:hover {
          background: #1e3a5f;
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(0);
          background: #1a2f4a;
        }

        &.max-selected {
          background: #ff7b00;

          &:hover {
            background: #e66a00;
          }

          &:active {
            background: #cc5c00;
          }
        }
      }
    }

    .amount-select {
      margin: 16px 0 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item {
        width: 70.332px;
        height: 38px;
        flex-shrink: 0;
        border-radius: 4px;
        border: 1px solid #d9dde5;
        cursor: pointer;
        transition: all 0.3s ease;
        color: #474747;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          background: #254774;
          border: 1px solid #254774;
          color: #fff;
        }

        &:active {
          transform: translateY(0);
        }
      }
    }
  }

  // 利率信息
  .rate-info {
    display: flex;
    align-items: center;
    gap: 6px;

    span {
      font-size: 12px;
      color: #1e7ca1;
      line-height: 21px;
    }

    img {
      width: 16px;
      height: 16px;
    }
  }

  // 产品详情卡片
  .product-details-card {
    position: relative;
    margin-top: 14px;

    .detail-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #eff6ff;

      &:last-child {
        border-bottom: none;
      }

      .label {
        font-size: 15px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 21px;
      }

      .value {
        font-weight: 500;
        font-size: 15px;
        color: rgba(0, 0, 0, 0.7);
        line-height: 21px;
        text-align: right;
      }
    }
  }

  .mobile-input-container {
    padding: 0 8px;
    margin: 20px 0 10px 0;
  }

  .mobile-input {
    height: 50px;
    border-radius: 25px;
    border: 1px solid #b1cdff;
    background: linear-gradient(90deg,
        rgba(7, 97, 214, 0.05) 0%,
        rgba(0, 89, 255, 0.05) 100%);
    box-shadow: 0 4px 4px 0 rgba(3, 92, 242, 0.12);
  }

  .link-text {
    color: #1e7ca1;
    font-weight: 500;
    font-size: 12px;
    line-height: 24px;
  }

  .agreement-text2 {
    margin-top: 16px;
    padding-left: 4px;
    text-align: center;
  }

  // 申请按钮
  .apply-button-container {
    width: 327px;
    margin: 0 auto;
    margin-top: 10px;

    .apply-button {
      width: 100%;
      height: 50px;
      background: linear-gradient(to right, #4d9bff, #67d1ff);
      border: 1px solid #cdedff;
      border-radius: 25px;
      box-shadow: 0px 4px 4px 0px rgba(3, 92, 242, 0.12);
      cursor: pointer;
      transition: all 0.3s ease;
      font-family: "Source_Han_Sans_CN", sans-serif;
      font-weight: bold;
      font-size: 16px;
      color: white;

      &.disabled {
        background: #cccccc;
        border: 1px solid #cccccc;
        box-shadow: none;
        cursor: not-allowed;
        color: #999999;
      }

      &.test-button {
        background: linear-gradient(to right, #ff9500, #ffb84d);
        border: 1px solid #ff9500;
      }
    }
  }
}

.sms-popup {
  width: 343px;

  .title {
    color: #254774;
    text-align: center;
    font-family: "Source Han Sans CN";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    margin-bottom: 24px;
    margin-top: 14px;
  }

  .sms-input {
    width: 300px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 25px;
    border: 1px solid #b1cdff;
    background: linear-gradient(90deg,
        rgba(7, 97, 214, 0.05) 0%,
        rgba(0, 89, 255, 0.05) 100%);
    box-shadow: 0 4px 4px 0 rgba(3, 92, 242, 0.12);
  }

  .btn-sms {
    color: #254774;
    font-family: "Source Han Sans CN";
    font-size: 16px;
    font-weight: 700;
    line-height: 21px;
    background: none;
    border: none;

    &:active::before {
      background: none;
    }

    &:disabled {
      color: #999999;
      cursor: not-allowed;
    }
  }
}

.copyright-box {
  padding-bottom: 20px;
  text-align: center;

  p {
    color: #939393;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
  }
}
</style>
